// extracted by mini-css-extract-plugin
export default {"SmallSpinner":"Prescription_SmallSpinner__DPd32","MapWrapper":"Prescription_MapWrapper__JqTya","Red":"Prescription_Red__0XRZJ"};